import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPresentation, refreshPresentation, refreshPresentationWithQuickPickTags, downloadPresentation, getSlideNotesDifference, getSlideNotesDifferenceTextOnly, clearPresentationView, getSlideImagesAndCharts } from '../../actions/presentationActions';
import { getQuery, setGlobal, setCurrentQPs } from '../../actions/queryActions';
import { getQPDataSource, getDataSource, getPresentationDataSource } from '../../actions/databaseActions';
import { showPopup, closePopup } from '../../actions/uiActions';
import { getCurrentUser } from '../../actions/userActions'
import { bindActionCreators } from 'redux';
import Slides from '../../components/main/Slides';

function SlidesContainer(props) {
    let navigate = useNavigate();
    let location = useLocation();
    let params = useParams();

    // State objects that control the page
    let [slide, setSlide] = useState(null);
    let [slideBegin, setSlideBegin] = useState(null);
    let [slideEnd, setSlideEnd] = useState(null);
    let [flag, setFlag] = useState(false);
    let [savedMessageState, setSavedMessageState] = useState(false);
    let [slidesLoaded, setSlidesLoaded] = useState(0)

    // trigger on component mount
    useEffect(() => {
        if (Object.keys(props.presentationView).length === 0 && !props.showError && !props.singlePresentationCheck) {
            props.getPresentation(params.id);
        }
        if (props.presentationView !== null && props.presentationView.slides !== undefined) {
            setSlideBegin(1);
            setSlideEnd(props.presentationView.slides.length);
        }

        if (props.currentUser === null) {
            props.getCurrentUser(props.userID);
        }

        if (!flag && props.presentationView.slides && props.presentationView.slides.length > 0 && props.presentationView.slides[0].slideImage) {
            if (props.presentationView.slides[0].slideImage.imageBytes === null) {
                getPresentationSlideImagesAndChartImages(props.presentationView.id)
            }


            if (location.pathname.includes("slides") && props.presentationView.slides) {
                viewSlide(location.pathname.split('/')[5]);
            } else {
                viewSlide("1");
            }
            setFlag(true);
        }
    });

    // componentDidUpdate equivilant
    useEffect(() => {
        if (props.message !== null && props.message.includes('Your presentation was updated') && !savedMessageState) {
            setSavedMessageState(true)
        } else if (props.message === null && savedMessageState) {
            setSavedMessageState(false)
            setFlag(false)
            props.clearPresentationView()
            props.getPresentation(params.id)
            props.closePopup()
        }
    }, [props.message]);

    function showQuickPickEditor(qpId) {
        if (props.qpDataSource === null) {
            props.getQPDataSource(props.presentationView.connectionInfos[0].id, 0, "qpPopup", null, false, qpId);
        } else {
            props.showPopup("qpPopup");
        }
        props.setCurrentQPs(props.presentationView.quickPicks);
    };

    function showChartQueryEditor(chartId) {
        let selectedChartId = (chartId) ? chartId : null;
        if (props.currentDatabase === null) {
            props.getPresentationDataSource(props.presentationView.connectionInfos[0].id, 0, "chartQueryPopup", { slide: getLatestSlideInformation(slide, props.presentationView), chartId: selectedChartId, quickPicks: props.presentationView.quickPicks, globals: props.presentationView.globals }, false);
        } else {
            props.showPopup("chartQueryPopup", { slide: getLatestSlideInformation(slide, props.presentationView), chartId: selectedChartId, quickPicks: props.presentationView.quickPicks, globals: props.presentationView.globals });
        }
    }

    function showSlideVersionHistory() {
        if (!props.presentationSlideChanges.includedTags) {
            props.getSlideNotesDifferenceTextOnly(props.presentationView.presentationID);
        }

        props.showPopup("SlideHistoryPopup", {
            slides: props.presentationView.slides,
            presentationId: props.presentationView.presentationID,
            parentPresentationId: (props.presentationView.presentation.parentPresentation) ? props.presentationView.presentation.parentPresentation.id : 0
        });
    };

    function showEditStory() {
        if (!props.presentationSlideChanges.includedTags) {
            props.getSlideNotesDifference(props.presentationView.presentationID)
        }

        props.showPopup("EditStoryPopup", {
            slideChanges: props.presentationSlideChanges,
            slides: props.presentationView.slides,
            presentationId: props.presentationView.presentationID,
            parentPresentationId: props.presentationView.presentation.parentPresentation.id
        });
    };

    function showGlobalEditor(globalID) {
        props.setGlobal(props.presentationView.globals.find(x => x.id === parseFloat(globalID)));
        navigate(`/presentations/powerpoint/${props.presentationView.presentationID}/globals/${globalID}`);
    }

    function viewSlide(id) {
        navigate(`/presentations/powerpoint/${props.presentationView.presentationID}/slides/${id}`, { replace: true });
        setSlide(props.presentationView.slides.find(x => x.slideNumber === parseFloat(id)));
    }

    function openQuery(id)  {
        props.getQuery(id);
        navigate(`/queries/${id}`);
    }

    function handleRefreshPresentation(id, connId, globals, editQuickPickIDs, quickPickAliases) {
        props.refreshPresentation(id, 0, connId, [], editQuickPickIDs, quickPickAliases);
        navigate('/presentations');
    }

    function handleRefreshPresentationWithQuickPickTags(id, globals, quickPickTags) {
        props.refreshPresentationWithQuickPickTags(id, globals, quickPickTags);
        navigate('/presentations');
    }

    function getLatestSlideInformation(slide, presentationView) {
        let rtnVal = slide

        if (slide !== null && slide !== undefined &&
            presentationView !== null && presentationView !== undefined &&
            presentationView["slides"] !== null && presentationView["slides"] !== undefined) {

            presentationView.slides.forEach(s => {
                if (s["slideId"] === slide["slideId"]) {
                    rtnVal = s
                }
            })
        }

        return rtnVal;
    }

    function getIndividialPresentationSlideImagesAndChartImages(presentationId, slideId) {
        props.getIndividualSlideImagesAndCharts(presentationId, slideId).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            let images = json["images"]
            let chartImages = json["chartImages"]

            for (let i = 0; i < images.length; i++) {
                setImageBytes(images[i]["id"], images[i]["imageBytes"])
                for (let j = 0; j < chartImages.length; j++) {
                    if (chartImages[j]["xP3SlideID"] === images[i]["xP3SlideID"]) {
                        setImageChartBytes(chartImages[j]["xP3SlideID"], chartImages[j])
                    }
                }
            }
        })
    }

    function getPresentationSlideImagesAndChartImages(presentationId) {
        props.getSlideImagesAndCharts(presentationId).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
        .then((json) => {
            let images = json["images"]
            let chartImages = json["chartImages"]

            for (let i = 0; i < images.length; i++) {
                setImageBytes(images[i]["id"], images[i]["imageBytes"])
                for (let j = 0; j < chartImages.length; j++) {
                    if (chartImages[j]["xP3SlideID"] === images[i]["xP3SlideID"]) {
                        setImageChartBytes(chartImages[j]["xP3SlideID"], chartImages[j])
                    }
                }
            }
        })
    }

    function setImageBytes(imageId, imageBytes) {
        for (let x = 0; x < props.presentationView.slides.length; x++) {
            if (props.presentationView.slides[x].slideImage.id == imageId) {
                props.presentationView.slides[x].slideImage.imageBytes = imageBytes
                setSlidesLoaded(slidesLoaded++)
            }
        }
    }

    function setImageChartBytes(slideId, chartData) {
        for (let x = 0; x < props.presentationView.slides.length; x++) {
            if (props.presentationView.slides[x].id == slideId) {
                for (let y = 0; y < props.presentationView.slides[x].xP3Charts.length; y++) {
                    if (props.presentationView.slides[x].xP3Charts[y].id === chartData.id) {
                        props.presentationView.slides[x].xP3Charts[y].imageBytes = chartData.imageBytes
                        props.presentationView.slides[x].xP3Charts[y].chartWidth = chartData.chartWidth
                        props.presentationView.slides[x].xP3Charts[y].chartHeight = chartData.chartHeight
                        setSlidesLoaded(slidesLoaded++)
                    }
                }
            }
        }
    }

    function doAllSlidesHaveTheirImagesLoaded() {
        if (props.presentationView.slides) {
            for (let x = 0; x < props.presentationView.slides.length; x++) {
                if (props.presentationView.slides[x].slideImage.imageBytes === null) {
                    return false
                }
            }
            return true
        }
        return false
    }

    function getPresentationSlideImagesAndChartImages(presentationId) {
        props.getSlideImagesAndCharts(presentationId).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
        .then((json) => {
            let images = json["images"]
            let chartImages = json["chartImages"]

            for (let i = 0; i < images.length; i++) {
                setImageBytes(images[i]["id"], images[i]["imageBytes"])
                for (let j = 0; j < chartImages.length; j++) {
                    if (chartImages[j]["xP3SlideID"] === images[i]["xP3SlideID"]) {
                        setImageChartBytes(chartImages[j]["xP3SlideID"], chartImages[j])
                    }
                }
            }
        })
    }

    function setImageBytes(imageId, imageBytes) {
        for (let x = 0; x < props.presentationView.slides.length; x++) {
            if (props.presentationView.slides[x].slideImage.id == imageId) {
                props.presentationView.slides[x].slideImage.imageBytes = imageBytes
                setSlidesLoaded(slidesLoaded++)
            }
        }
    }

    function setImageChartBytes(slideId, chartData) {
        for (let x = 0; x < props.presentationView.slides.length; x++) {
            if (props.presentationView.slides[x].id == slideId) {
                for (let y = 0; y < props.presentationView.slides[x].xP3Charts.length; y++) {
                    if (props.presentationView.slides[x].xP3Charts[y].id === chartData.id) {
                        props.presentationView.slides[x].xP3Charts[y].imageBytes = chartData.imageBytes
                        props.presentationView.slides[x].xP3Charts[y].chartWidth = chartData.chartWidth
                        props.presentationView.slides[x].xP3Charts[y].chartHeight = chartData.chartHeight
                        setSlidesLoaded(slidesLoaded++)
                    }
                }
            }
        }
    }

    function doAllSlidesHaveTheirImagesLoaded() {
        if (props.presentationView.slides) {
            for (let x = 0; x < props.presentationView.slides.length; x++) {
                if (props.presentationView.slides[x].slideImage.imageBytes === null) {
                    return false
                }
            }
            return true
        }
        return false
    }

    // Render
    if (location.pathname.includes("download") && Object.keys(props.presentationView).length > 0 && !props.downloadCheck) {
        props.downloadPresentation(props.presentationView.presentationID, props.presentationView.presentation.name + ".pptx");
    }

    return <Slides
        presentationView={props.presentationView}
        getPresentation={props.getPresentation}
        slide={slide}
        viewSlide={viewSlide}
        {...props}
        openQuery={openQuery}
        handleRefreshPresentation={handleRefreshPresentation}
        handleRefreshPresentationWithQuickPickTags={handleRefreshPresentationWithQuickPickTags}
        slideBegin={slideBegin}
        slideEnd={slideEnd}
        getQPDataSource={props.getQPDataSource}
        showGlobalEditor={showGlobalEditor}
        showQuickPickEditor={showQuickPickEditor}
        showChartQueryEditor={showChartQueryEditor}
        downloadPresentation={props.downloadPresentation}
        isPresentationBigLoaded={props.isPresentationBigLoaded}
        currentUser={props.currentUser}
        presentationSlideChanges={props.presentationSlideChanges}
        showSlideVersionHistory={showSlideVersionHistory}
        showEditStory={showEditStory}
        slidesLoaded={slidesLoaded}
        doAllSlidesHaveTheirImagesLoaded={doAllSlidesHaveTheirImagesLoaded()} />;
}

function mapStateToProps(state) {
    return {
        presentationView: state.presentations.present.presentationView,
        presentationSlideChanges: state.presentations.present.presentationSlideChanges,
        showError: state.ui.showError,
        currentDataSource: state.databases.currentDataSource,
        modifiedGlobals: state.queries.present.modifiedGlobals,
        modifiedQPs: state.queries.present.modifiedQPs,
        downloadCheck: state.presentations.present.downloadCheck,
        singlePresentationCheck: state.presentations.present.singlePresentationCheck,
        qpDataSource: state.databases.qpDataSource,
        isPresentationBigLoaded: state.presentations.present.isPresentationBigLoaded,
        presentationsProgress: state.presentations.present.presentationsProgress,
        completedLoad: state.presentations.present.completedLoad,
        currentDatabase: state.databases.currentDatabase,
        currentUser: state.users.currentUser,
        userID: state.users.userID,
        message: state.ui.message
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(
            {
                getPresentation,
                getQuery,
                refreshPresentation,
                refreshPresentationWithQuickPickTags,
                getQPDataSource,
                getDataSource,
                getPresentationDataSource,
                setGlobal,
                setCurrentQPs,
                downloadPresentation,
                showPopup,
                getCurrentUser,
                getSlideNotesDifference,
                getSlideNotesDifferenceTextOnly,
                closePopup,
                clearPresentationView,
                getSlideImagesAndCharts
            }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SlidesContainer)